export default {
  'Welcome!': 'Välkommen!',
  'Joint ID': 'Databas-id',
  'Skarv-ID': 'Skarv-ID',
  'Database ID': 'Databas-id',
  'Sub Contractor': 'Utförare',
  'Customer users': 'Kundens användare',
  'Add user to this customer': 'Lägg till användare till denna kund',
  'Failed to save new user': 'Det gick inte att spara ny användare',
  'Export to Excel': 'Exportera till Excel',
  'Failed to export Excel': 'Det gick inte att exportera till Excel',
  'End date is required': 'Slutdatum är obligatoriskt',
  'Please fill in all required fields': 'Vänligen fyll i alla obligatoriska fält',
  'Bulk article': 'Bulkartiklar',
  'Search by article number or name': 'Sök på artikelnummer eller namn',
  'No matches': 'Inga träffar',
  'Search for articles to add. Selected articles will appear here.': 'Sök efter artiklar att lägga till. Valda artiklar visas här.',
  'Add selected': 'Lägg till valda',
  'Qty': 'Antal',
  'No articles selected': 'Inga artiklar valda',
  '{0} articles selected': '{0} artiklar valda',
  'Added {0} articles': '{0} artiklar tillagda',
  'Failed to add some articles': 'Det gick inte att lägga till alla artiklar',
  'Stock After': 'Lagersaldo efter',
  'Audit': 'Inventering',
  'Show chart': 'Visa diagram',
  'Hide chart': 'Dölj diagram',
  'No data to chart': 'Ingen data att visa',
  'Joint Log': 'Svetsrapport',
  'Home': 'Hem',
  'ID': 'ID',
  'Reminder': 'Påminnelse/Notis',
  'Reminder: ': 'Påminnelse: ',
  'Alarm': 'Alarm',
  'temps': 'Temperaturer °C',
  'Temperature': 'Temperatur',
  'Joints': 'Skarvar',
  'Select welds': 'Välj skarvar',
  'Current Report': 'Valda rapportrader',
  'Current Equipment': 'Nuvarande hyrd utrustning',
  'Joints welded over time': 'Antal svetsade skarvar över tid',
  'Equipment': 'Utrustning',
  ' Equipment': 'Utrustning',
  'Timestamp': 'Tidsstämpel',
  'timestamp': 'Tidsstämpel',
  'Welds': 'Svetsningar',
  'Actions': 'Åtgärder',
  'Report Preview': 'Förhandsgranska',
  'Page:': 'Sida:',
  'Filters': 'Filter',
  'Print Stock List': 'Skriv ut lagerlista',
  'Barcode': 'Streckkod',
  'Failed to generate stock list': 'Kunde inte generera lagerlista',
  'This Week': 'Denna vecka',
  'This Month': 'Denna månad',
  'This Year': 'I år',
  'January_February_March_April_May_June_July_August_September_October_November_December': 'Januari_Februari_Mars_April_Maj_Juni_Juli_Augusti_September_Oktober_November_December',
  'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec': 'Jan_Feb_Mar_Apr_Maj_Jun_Jul_Aug_Sep_Okt_Nov_Dec',
  'Mo_Tu_We_Th_Fr_Sa_Su': 'Må_Ti_On_To_Fr_Lö_Sö',
  'Previous': 'Föregående',
  'Reloading data..': 'Uppdaterar tabellen..',
  'Data reloaded': 'Tabellen uppdaterad',
  'Add to report': 'Lägg till i rapport',
  'Next': 'Nästa',
  'Rental Start Date': 'Startdatum hyrperiod',
  'Rental End Date': 'Slutdatum hyrperiod',
  'Map': 'Karta',
  'Show map': 'Visa karta',
  'Hide map': 'Dölj karta',
  'Showing the latest 1000 welds.': 'Visar de senaste 1000 svetsarna.',
  'Use filters to narrow down results.': 'Använd filter för att begränsa resultaten.',
  'Password': 'Lösenord',
  'The password is required!': 'Vänligen ange lösenord!',
  'Password must be at least {1} characters': 'Lösenordet måste vara minst {1} tecken',
  'Create User': 'Skapa användare',
  'First Name': 'Förnamn',
  'Last Name': 'Efternamn',
  'E-mail': 'E-post',
  'User list': 'Användare',
  'Create new user': 'Skapa ny användare',
  'Edit': 'Redigera',
  'Delete': 'Radera',
  'Delete Image': 'Radera bild',
  'Confirm Delete': 'Bekräfta radering',
  'Are you sure you want to delete this image?': 'Är du säker på att du vill radera denna bild?',
  'This action cannot be undone.': 'Denna åtgärd kan inte ångras.',
  'User Profile': 'Användarprofil',
  'Save': 'Spara',
  'User Companies': 'Företagsbehörigheter',
  'Select companies': 'Välj företag',
  'Save Companies': 'Spara företag',
  'Welding Report': 'Svetsrapport',
  'Welding Machine': 'Svetsmaskin',
  'Welding Machines': 'Svetsmaskiner',
  'Created by:': 'Skapad av:',
  'Company:': 'Företag:',
  'of': 'av',
  'Remove': 'Radera',
  'Clear Report': 'Rensa allt',
  'Preview Report': 'Förhandsgranska',
  'Print Report': 'Skriv ut',
  'Download PDF': 'Ladda ner PDF',
  'Failed to generate PDF': 'Kunde inte skapa PDF',
  'Are you sure?': 'Är du säker?',
  'Delete work order?': 'Ta bort arbetsorder?',
  'This will permanently delete the work order including all order rows and attached risk reports.': 'Detta kommer permanent ta bort arbetsordern inklusive alla orderrader och bifogade riskrapporter.',
  'Sign In to your account': 'Logga in nedan för att komma åt MittLog-portalen.',
  'Email': 'E-post',
  'Forgot password?': 'Glömt lösenordet?',
  'Logging in..': 'Loggar in..',
  'Access Denied': 'Inloggning misslyckades',
  'Map (Only shows welding machines)': 'Karta (Visar endast svetsmaskiner)',
  'All': 'Alla',
  'Machine ID': 'Maskin-ID',
  'icon-110': 'icon-power',
  'Ongoing': 'Pågående',
  'Historical equipment rentals': 'Tidigare hyrd utrustning',
  'On': 'På',
  'Off': 'Av',
  'Equipment ID (If applicable)': '',
  'Description': '',
  'Write a description of what happened..': '',
  'Alert customer to send back equipment': '',
  'Date': 'Datum',
  'Reason': 'Anledning',
  'Created by': 'Skapad av',
  'Customer Log': 'Kundlogg',
  'Create Log Entry': '',
  'Support - Phone': 'Support - Telefon',
  'Support - E-mail': 'Support - Mejl',
  'Sales - Phone': 'Säljsamtal - Telefon',
  'Sales Activity - Campaign, Email etc.': 'Säljaktivitet - Kampanj, Mejl etc.',
  'Slug': 'Slug',
  'Subject': 'Ämne',
  'Email Templates': 'Mejl-mallar',
  'Revision Date': 'Revisionsdatum',
  'CPU': 'CPU',
  'Filename 1': 'Filnamn 1',
  'Filename 2': 'Filnamn 2',
  'Revisions': 'Revisioner',
  'Revision': 'Revision',
  'Upload new revision': 'Ladda upp ny revision',
  'Equipment ID': 'Utrustnings-ID',
  '# CPUs': '# CPUer',
  'Create Equipment Specification': 'Skapa Maskinspecifikation',
  'Display': 'Display',
  'Styrkort': 'Styrkort',
  'Latest rev CPU 1': 'Senaste rev CPU 1',
  'Latest rev CPU 2': 'Senaste rev CPU 2',
  'Equipment Specifications': 'Maskinspecifikation',
  'Create specification': 'Skapa specifikation',
  'Old': 'Gammalt',
  'New': 'Nytt',
  'Create Update Entry': 'Skapa uppdateringsjobb',
  'Update Queue': 'Uppdateringskö',
  'Create update entry': 'Skapa uppdateringsjobb',
  '[Welcome Title]': 'Välkommen, ',
  '[Welcome Body]': 'Denna portal ger dig insikt i detaljerna kring de svetsningar som görs på ert företag. Använd menyn till vänster för att navigera.',
  'Number of joints': 'Antal skarvar',
  'Dimension': 'Dimension',
  'Select a Machine ID': 'Välj ett Maskin-ID',
  'Choose the equipment related to your message (optional)': 'Välj den utrustning som ärendet rör (frivilligt)',
  '-- Nothing Selected --': '-- Ingen vald --',
  'Message': 'Meddelande',
  'Write your message here': 'Skriv ditt meddelande här',
  'I want to send back the equipment': 'Jag vill skicka tillbaka utrustningen',
  'Contact Support': 'Kontakta Support',
  'Send message': 'Skicka meddelande',
  'Login': 'Logga in',
  'Logout': 'Logga ut',
  'Users': 'Användare',
  'Firmware Revisions': 'Mjukvaror',
  'Equipment Spec.': 'Maskinspec.',
  'Remote Update': 'Fjärruppdatering',
  'Dashboard': 'Översikt',
  'Current': 'Nuvarande',
  'Historical': 'Historik',
  'Weld Report': 'Svetsrapport',
  'Weld Report for ': 'Svetsrapport för ',
  'Support': 'Support',
  'joint_time_a': 'Total svetstid',
  'u_mains': 'Spänning',
  'u_mains_min_max': 'Min/Max Spänning',
  'mode': 'Mode',
  'alarm': 'Alarm',
  'channel': 'Kanal',
  'dimension': 'Dimension',
  'name': 'Namn',
  'Report Name:': 'Rapportnamn:',
  'Comment': 'Kommentar',
  'Joint Comment': 'Kommentar',
  'Write a report name.. (optional)': 'Skriv ett rapportnamn.. (valfritt)',
  'Report name:': 'Rapportnamn:',
  'Add all to report': 'Lägg till alla',
  'Per page': 'Antal per sida',
  'ALARM-0': 'Inget larm',
  'ALARM-1': 'Faulty Converter',
  'ALARM-2': 'Log Memory Full',
  'ALARM-4': '10min Timeout',
  'ALARM-8': 'Tool Problem',
  'ALARM-16': 'Open Cable',
  'ALARM-32': 'Boost Timeout',
  'ALARM-64': 'Overheated',
  'ALARM-128': 'Shorted Cable',
  'TIME-min': 'min',
  'TIME-sec': 'sek',
  'Seconds': 'Sekunder',
  'Minutes': 'Minuter',
  'Select a Dimension': 'Filtrera på dimension',
  'Customer': 'Kund',
  'Work Order': 'Arbetsorder',
  'Draft': 'Utkast',
  'New Picklist': 'Ny plocklista',
  'All Picklists': 'Alla plocklistor',
  'Title': 'Titel',
  'Start date': 'Startdatum',
  'End date': 'Slutdatum',
  'Responsible seller': 'Ansvarig säljare',
  'Street address': 'Gatuadress',
  'Zip code': 'Postnummer',
  'City': 'Stad',
  'Customer Project/Reference': 'Kundens projekt/ref.',
  'Project Phase': 'Kundens etapp',
  'Coil To': 'Slinga tillopp',
  'Coil From': 'Slinga retur',
  'Coil VV/VVC': 'Slinga VV/VVC',
  'Pipe manufacturer': 'Rörtillverkare',
  'Base city': 'Basort',
  'Isolation To': 'Isolation tillopp',
  'Isolation From': 'Isolation retur',
  'Discrepancy report': 'Avvikelserapport',
  'Density test': 'Täthetsprovning',
  'Temp outside': 'Temp ute',
  'Coil Twin': 'Slinga twin',
  'Isolation Twin': 'Isolation twin',
  'Alarm connected': 'Larm kopplat',
  'Had blueprint': 'Larmritning fanns',
  'Work description': 'Arbetsbeskrivning',
  'Work done by': 'Arbetet utfört av',
  'Work orders': 'Arbetsordrar',
  'Contact': 'Kontakt',
  'Back': 'Bakåt',
  'Print': 'Skriv ut',
  'Articles': 'Artiklar',
  'Created': 'Skapad',
  'Update': 'Uppdatera',
  'Article': 'Artikel',
  'Quantity': 'Antal',
  'Quantity missing': 'Antal saknas',
  'Unit': 'Enhet',
  'Work Orders': 'Arbetsordrar',
  'New Work Order': 'Ny arbetsorder',
  'View my work orders': 'Mina arbetsordrar',
  'All Orders': 'Alla',
  'Job Reporting': 'Jobbrapportering',
  'Create new work order': 'Skapa ny arbetsorder',
  'bend': 'böj',
  'Person': 'Person',
  'MSI': 'MSI',
  'Information': 'Information',
  'Work Order List': 'Arbetsordrar',
  'All work orders': 'Alla arbetsordrar',
  'Mine': 'Mina ordrar',
  'My work orders': 'Mina arbetsordrar',
  'Ready for invoicing': 'Klar för fakturering',
  'Info': 'Info',
  'Printed': 'Utskrivna',
  'Not printed': 'Ej utskrivna',
  'Status': 'Status',
  'Overview': 'Översikt',
  'Rak': 'Rak',
  'TSC': 'TSC',
  'Krymp': 'Krymp',
  'TSC-Krymp': 'TSC-Krymp',
  'TSC dn': 'TSC Dy',
  'Twin': 'Twin',
  'Gir >3gr': 'Gir >3gr',
  'Reduction': 'Reduktion',
  'Incl. sleeve': 'Inkl. muff',
  'End sleeve': 'Ändmuff',
  'Rep': 'Rep',
  'Protective sleeve': 'Skyddsmuff',
  'Add': 'Lägg till',
  'T-stycke': 'T-stycke',
  'Single T-Pipe': 'Enkelt T-stycke',
  'Double T-Pipe': 'Dubbelt T-stycke',
  'Stam dn': 'Stam Dy',
  'Avg dn': 'Avg Dy',
  'Lilla dn': 'Lilla Dy',
  'Stam red 1 dn': 'Stam red 1 Dy',
  'Stam red 2 dn': 'Stam red 2 Dy',
  'Select': 'Välj',
  'Avgrening 45gr': 'Avgrening 45gr',
  'Avgrening 90gr': 'Avgrening 90gr',
  'Stam Reduction': 'Stamreduktion',
  'Böj': 'Böj',
  'Angle up to 45°': 'Böj upp till 45°',
  'Angle more than 45°': 'Böj mer än 45°',
  'Quick add': 'Snabbval',
  'Search articles': 'Sök artikel',
  'Select an article': 'Välj artikel',
  'Add article': 'Lägg till artikel',
  'Customers': 'Kunder',
  'Admin': 'Admin',
  'Create new article': 'Skapa ny artikel',
  'Art. No': 'Art. No',
  'Default unit': 'Standardenhet',
  'Favorite': 'Favorit',
  'Clear': 'Rensa val',
  'Set status printed': 'Ändra status till Utskriven',
  'Set status ready for invoicing': 'Sätt status Klar för fakturering',
  'If you have alarm values, please input them below.': 'Om du har alarm-värden måste dessa fyllas i nedan.',
  'Change password': 'Ändra lösenord',
  'Old password': 'Gammalt lösenord',
  'New password': 'Nytt lösenord',
  'Enter new password again': 'Ange det nya lösenordet igen',
  'Minimum 6 characters': 'Minimum 6 tecken',
  'Minimum 8 characters': 'Minimum 8 tecken',
  'Reset Password': 'Återställ lösenord',
  'Enter your email address': 'Ange din e-postadress',
  'Send reset link': 'Skicka återställningslänk',
  'If the email exists, a reset link has been sent.': 'Om adressen finns registrerad har en återställningslänk skickats.',
  'Your password has expired. Please set a new password.': 'Ditt lösenord har gått ut. Vänligen ange ett nytt lösenord.',
  'Confirm password': 'Bekräfta lösenord',
  'Password reset successful. Please log in.': 'Lösenordet har återställts. Vänligen logga in.',
  'Invalid or expired reset link.': 'Ogiltig eller utgången återställningslänk.',
  'Password must be at least 8 characters': 'Lösenordet måste vara minst 8 tecken',
  'Password changed.': 'Lösenordet har ändrats.',
  'Logging in, please wait..': 'Loggar in, vänligen vänta..',
  'Order responsible': 'Orderansvarig',
  'stored': 'Internt ID',
  'Add new rental': 'Ny uthyrning',
  'New status': 'Ny status',
  'New customer': 'Ny kund',
  'Print picklists and set status': 'Skriv ut plocklista och ändra status',
  'Because the new status is to Service the customer will automatically be set to Mittel :)': 'Eftersom status är Service så kommer kunden automatiskt sättas till Mittel',
  'New rental start date': 'Startdatum',
  'Cancel': 'Avbryt',
  'Rental': 'Uthyrning',
  'Create rental': 'Skapa uthyrning',
  'Search equipment': 'Sök utrustning',
  'Search customer': 'Sök kund',
  'Ort/Placering': 'Ort/Placering',
  'Contact person': 'Kundens kontaktperson',
  'Sales responsible': 'Säljansvarig',
  'End last rental period': 'Avsluta föregående uthyrningsperiod för utrustningen',
  'All Rentals': 'Alla uthyrningar',
  'Search..': 'Sök..',
  'Type': 'Typ',
  'Company': 'Kund',
  'Ort': 'Ort',
  'Rentals': 'Uthyrningar',
  'Model': 'Modell',
  'Model (optional)': 'Modell (frivilligt)',
  'Equipment Number': 'Utrustnings-ID',
  'Serial no is required': 'Serienummer är obligatoriskt',
  'Serial must be at least {1} characters': 'Serienumret behöver vara minst {1} tecken',
  'Hidden': 'Dold',
  'Comment (optional)': 'Kommentar (frivillig)',
  'Create Equipment': 'Skapa utrustning',
  'Equipment list': 'Utrustning',
  'Create new equipment': 'Skapa ny utrustning',
  'New Rental': 'Ny uthyrning',
  'Equipment Type': 'Utrustningstyp',
  'Equipment Model': 'Utrustningsmodell',
  'Remember me': 'Kom ihåg mig',
  'First name': 'Förnamn',
  'Last name': 'Efternamn',
  'Phone': 'Telefon',
  'High risk!': 'Hög risk!',
  'The risk analysis includes a high risk.\n\nTo solve this, either reach out to your contact person at the client or André From, 070-236 88 45.': 'Riskanalysen innehåller en hög risk.\n\nFör att avhjälpa risken, kontakta antingen din kontaktperson hos beställaren eller André From, 070-236 88 45.',
  'WARNING: High risk detected!': 'VARNING: Hög risk upptäckt!',
  'The following high-risk issues were identified:': 'Följande högriskproblem identifierades:',
  'Please contact safety coordinator immediately:': 'Kontakta säkerhetskoordinatorn omedelbart:',
  'Phone: +46 123 456 789': 'Telefon: +46 123 456 789',
  'Do you still want to create this work order?': 'Vill du fortfarande skapa denna arbetsorder?',
  'Only active rentals': 'Endast aktiva uthyrningar',
  'Only companies with active rentals': 'Endast företag med aktiva uthyrningar',
  'S-angle': 'S-böj',
  'Write a reminder here..': 'Skriv påminnelse här..',
  'Edit equipment': 'Redigera utrustning',
  'Hide from other parts of portal?': 'Dölj från andra delar av portalen?',
  'Equipment Types': 'Utrustningstyper',
  'Create new equipment type': 'Skapa ny utrustningstyp',
  'Create Equipment Type': 'Skapa utrustningstyp',
  'Type Number (ex. 110)': 'Typnummer (ex. 110)',
  'Type name': 'Typnamn',
  'Create new equipment model': 'Skapa ny utrustningsmodell',
  'Equipment Models': 'Utrustningsmodeller',
  'Create Equipment Model': 'Skapa utrustningsmodell',
  'Model name': 'Modellnamn',
  'Name': 'Namn',
  'Edit Equipment Model': 'Redigera utrustningsmodell',
  'Create New Work Order': 'Skapa ny arbetsorder',
  'Latest audit': 'Inv. i år',
  ' Mark as audited': ' Markera som inventerad',
  'STOCK_AUDIT': 'Inventering',
  'GENERAL_COMMENT': 'Notering',
  'Equipment Comment Log': 'Utrustningslogg',
  'Add comment for equipment: ': 'Lägg till kommentar för utrustning: ',
  'FoamCalc': 'SkumCalc',
  'Density mix': 'Densitet mix (oskummad)',
  'Calculate empty volume': 'Räkna tom volym',
  'Density': 'Densitet',
  'Weld type': 'Skarvtyp',
  'ISO:Poly Volume Ratio': 'ISO:Poly volymförhållande',
  'Plastic (mm)': 'Plast (mm)',
  'Steel (mm)': 'Stål (mm)',
  'Length (cm)': 'Längd (cm)',
  'Shortcuts': 'Snabbgenvägar',
  'Temporary rentals': 'Tillfälliga uthyrningar',
  'View alert lists': 'Visa larmlista',
  'Add new contact for customer': 'Lägg till ny kundkontakt',
  'processDone': 'Svetsning slutförd',
  'weld_complete': 'Ja',
  'weld_aborted': 'Nej, avbruten',
  'weld_unknown': 'Okänt',
  'Yes': 'Ja',
  'No': 'Nej',
  'Show hidden equipment': 'Visa dold utrustning',
  'Knowledge Base': 'Kunskapsdatabas',
  'Length (default 75m if not specified)': 'Längd (tomt = 75m)',
  '1. Choose number of fläta to create and default settings': '1. Ange antal, längd och intern/extern',
  '2. Edit details if needed': '2. Granska/redigera enskilda flätrullar',
  'Latest ID:': 'Senaste ID',
  'Quality': 'Kvalitet',
  'Length': 'Längd',
  'Internal': 'Internt',
  'Create': 'Skapa',
  'It seems like this work order already exists in BC with order number: ': 'Det verkar som att denna arbetsorder redan finns i BC med ordernummer: ',
  'This work order will not be sent to BC again. Please edit the existing work order in BC instead.': 'Arbetsordern kommer inte skickas igen. Vänligen redigera ordern direkt i BC istället.',
  'Stocked date': 'Lagerförd',
  'Checkout fläta': 'Checka ut fläta',
  'Add to checkout': 'Lägg till i utcheckning',
  'Color': 'Färg',
  'Sent Date': 'Skickat datum',
  'Nothing selected': 'Inget valt',
  'Filter by status': 'Filtrera status',
  'Sent by': 'Skickad av',
  'Create work order with article': 'Skapa arbetsorder med artikeln',
  'Sync BC': 'Synka med BC',
  'New Flata': 'Ny fläta',
  'My Profile': 'Min profil',
  'Draft picklists': 'Utkast plocklistor',
  'Printed picklists': 'Utskrivna plocklistor',
  'Picklists': 'Plocklistor',
  'Create New Picklist': 'Skapa ny plocklista',
  'Picklist': 'Plocklista',
  'Reference': 'Märke',
  'Order date': 'Orderdatum',
  'Order Contact Person': 'Leveranskontaktperson',
  'Zip Code': 'Postnummer',
  'Shipping address': 'Leveransadress',
  'Shipping city': 'Leveransstad',
  'Shipping country': 'Leveransland',
  'Billing address': 'Fakturaadress',
  'Billing city': 'Fakturastad',
  'Billing country': 'Fakturaland',
  'Use same address for shipping': 'Använd samma adress som leveransadress',
  'blueprint': 'ritning',
  'Blueprint': 'Ritning',
  'Custom': 'Anpassad',
  'Name/Company': 'Namn/Företag',
  'Audit Stock': 'Inventera',
  'From ID': 'Från ID',
  'To ID': 'Till ID',
  'Selected equipment': 'Vald utrustning',
  'The fields below might be filled in automatically based on the equipment you selected.': 'Fälten nedan förifylls automatiskt baserat på den första utrustningen du valt.',
  'Warning: There are conflicts in the statuses or rental dates of the selected equipment. Please resolve them before saving.': 'Varning: Den valda utrustningen har olika statusar, eller så är senaste uthyrningsperioden för en utrustning redan avslutad (sista uthyrningsperioden bör alltid vara pågående). Vänligen korrigera detta separat innan du checkar ut flera utrustningar samtidigt.',
  'Use the quick add below to add a standard address to the picklist or leave blank and add your own address.': 'Använd snabbvalet nedan fr att lägga till en av de vanligaste adresserna eller lämna blankt och lägg till din egen adress.',
  'Fläta Comment Log': 'Inventeringslogg',
  'Foam Weighing': 'Skumvägning',
  'Upload foam weighing database': 'Ladda upp databasfil',
  'Upload new foam weighing database': 'Ladda upp ny databas för skumvägning',
  'Audit all marked': 'Inventera alla markerade',
  'Quick Add Picklist': 'Snabbval Plocklista',
  'Quick Add List': 'Snabbval Lista',
  'Create new Quick Add': 'Skapa nytt Snabbval',
  'Shipping Name': 'Leveransnamn',
  'Street Address': 'Gatuadress',
  'Create Quick Add': 'Skapa Snabbval',
  'Quick Add Management': 'Snabbvalshantering',
  'Requested delivery date': 'Begärt leveransdatum',
  'Weld Overview': 'Översikt svetsmaskiner',
  'Create picklist with article': 'Skapa plocklista med artikel',
  'Activate Stock Level': 'Aktivera lagerhållning',
  'Stock List': 'Lageröversikt',
  'Stock': 'Lager',
  'Add Transaction': 'Skapa lagertransaktion',
  'Manual Adjustment': 'Manuell justering',
  'User': 'Användare',
  'ERROR: you need to grant camera access permission': 'FEL: du måste ge tillstånd till kameraåtkomst',
  'ERROR: no camera on this device': 'FEL: ingen kamera på denna enhet',
  'ERROR: secure context required (HTTPS, localhost)': 'FEL: säker anslutning krävs (HTTPS, localhost)',
  'ERROR: is the camera already in use?': 'FEL: används kameran redan?',
  'ERROR: installed cameras are not suitable': 'FEL: installerade kameror är inte lämpliga',
  'ERROR: Camera error': 'FEL: Kamerafel',
  'Please add at least one article with quantity': 'Lägg till minst en artikel med antal',
  'Stock transactions created successfully': 'Lagerförändringar skapades',
  'Failed to create stock transactions': 'Kunde inte skapa lagerförändringar',
  'Stock Admin': 'Lageradmin',
  'Stock Checkin': 'Lagerincheckning',
  'Stock Checkout': 'Lagerutcheckning',
  'New Stock': 'Ny lagerändring',
  'Start Scanning': 'Starta scanning',
  'Scan again': 'Scanna om',
  'Quantity exceeds available stock': 'Antalet överskrider tillgängligt lager',
  'Current stock level': 'Nuvarande lagersaldo',
  'Article Scanned': 'Artikel scannad, välj antal nedan',
  'Article not found or stock management not enabled': 'Artikel hittades inte eller så är lagerhållning inte aktiverad',
  'Remove from Stock': 'Ta ut från lager',
  'Add to Stock': 'Lägg till i lager',
  'Stock Audit': 'Lagerinventering',
  'Mode': 'Läge',
  'Add to Queue': 'Lägg till i kö',
  'Queued Changes': 'Köade ändringar',
  'Current Stock': 'Nuvarande lagersaldo',
  'New Stock Level': 'Nytt lagersaldo',
  'Adjustment': 'Justering',
  'Submit AUDIT': 'Skapa inventering',
  'Submit IN': 'Lägg till artiklarna',
  'Submit OUT': 'Ta ut artiklarna',
  'Submit All Changes': 'Spara alla ändringar',
  'Antal': 'Antal',
  'Stock History': 'Lagerhistorik',
  'History': 'Historik',
  'In Stock': 'Lagersaldo',
  'You have unsaved changes. Are you sure you want to go back? All changes will be lost.': 'Du har osparade ändringar. Är du säker på att du vill gå tillbaka? Alla ändringar kommer att förloras.',
  'Stock Items': 'Lagerartiklar',
  'Stock In': 'Inleverans',
  'Stock Out': 'Uttag',
  'Add Stock Transaction': 'Lägg till lagertransaktion',
  'Optional reason for these changes': 'Valfri anledning till dessa ändringar',
  '(Optional)': '(Frivilligt)',
  'What would you like to do?': 'Vad vill du göra?',
  'Stock Overview': 'Lageröversikt',
  'Stock Check-in': 'Lagerinleverans',
  'Stock Check-out': 'Lageruttag',
  'Print Barcodes': 'Skriv ut streckkoder',
  'Remove from report': 'Ta bort från rapport',
  'BC Order Number must start with OR followed by numbers': 'BC-ordernummer måste börja med OR följt av siffror',
  'Utrustning hittades och har automatiskt återaktiverats': 'Utrustning hittades och har automatiskt återaktiverats från dolt läge',
  'Risk Questions': 'Riskfrågor',
  'No Risk': 'Låg',
  'Low Risk': 'Låg',
  'Medium Risk': 'Medel',
  'High Risk': 'Hög',
  'Yellow': 'Låg',
  'Orange': 'Medel',
  'Red': 'Hög',
  'Green': 'OK',
  'Show comment/image form': 'Aktivera kommentarsfält & bilduppladdning',
  'Create new risk question': 'Skapa ny riskfråga',
  'Edit risk question': 'Redigera riskfråga',
  'Sort Order': 'Sorteringsordning',
  'Order': 'Ordning',
  'Enter display order (lower numbers appear first)': 'Ange visningsordning (lägre siffror visas först)',
  'Deactivate': 'Inaktivera',
  'Activate': 'Aktivera',
  'Are you sure you want to': 'Är du säker på att du vill',
  'this risk question?': 'denna riskfråga?',
  'deactivate': 'inaktivera',
  'activate': 'aktivera',
  'Error updating risk question status': 'Fel vid uppdatering av riskfrågans status',
  'Error updating question order': 'Fel vid uppdatering av frågornas ordning',
  'Question order updated successfully': 'Frågornas ordning uppdaterad framgångsrikt',
  'Move up': 'Flytta upp',
  'Move down': 'Flytta ner',
  'sub-questions': 'underfrågor',
  'Hide archived questions': 'Dölj arkiverade frågor',
  'Error loading risk question': 'Fel vid laddning av riskfråga',
  'Error saving risk question': 'Fel vid sparande av riskfråga',
  'Safe / No risk': 'Säkert / Ingen risk',
  'Risk identified': 'Risk identifierad',
  'Question Text': 'Frågetext',
  'Enter the risk assessment question': 'Ange riskbedömningsfrågan',
  'Risk Level': 'Risknivå',
  'Optional for neutral questions, required for risk scoring': 'Valfritt för neutrala frågor, krävs för riskbedömning',
  'No risk level (neutral)': 'Ingen risknivå (neutral)',
  'Active': 'Aktiv',
  'Archived': 'Arkiverad',
  'Create Risk Question': 'Skapa riskfråga',
  'Work Order Details': 'Arbetsorderdetaljer',
  'Risk Assessment': 'Riskbedömning',
  'Creating...': 'Skapar...',
  'Please answer the following risk assessment questions:': 'Vänligen besvara följande riskbedömningsfrågor:',
  'Not Applicable': 'Ej tillämpligt',
  'Additional Comments': 'Ytterligare kommentarer',
  'Enter any additional comments about the risk assessment...': 'Ange eventuella ytterligare kommentarer om riskbedömningen...',
  'Failed to load risk questions': 'Misslyckades med att ladda riskfrågor',
  'Error loading risk questions': 'Fel vid laddning av riskfrågor',
  'Error loading customers': 'Fel vid laddning av kunder',
  'Error loading customer contacts': 'Fel vid laddning av kundkontakter',
  'Error creating work order': 'Fel vid skapande av arbetsorder',
  'Risk Reports': 'Riskrapporter',
  'Based on latest report': 'Baserat på senaste rapporten',
  'total reports': 'totalt antal rapporter',
  'read more': 'läs mer',
  'read less': 'läs mindre',
  'No risk reports found for this work order.': 'Inga riskrapporter hittades för denna arbetsorder.',
  'Initial Report': 'Ursprungsrapport',
  'Report': 'Rapport',
  'Comments': 'Kommentarer',
  'Risk Assessment Answers': 'Riskbedömningssvar',
  'Question': 'Fråga',
  'Add New Risk Report': 'Lägg till ny riskrapport',
  'Add Risk Report': 'Lägg till riskrapport',
  'Failed to load risk reports': 'Misslyckades med att ladda riskrapporter',
  'Error loading risk reports': 'Fel vid laddning av riskrapporter',
  'Failed to create risk report': 'Misslyckades med att skapa riskrapport',
  'Error creating risk report': 'Fel vid skapande av riskrapport',
  'Failed to open print report': 'Misslyckades med att öppna utskrift av rapport',
  'Add Admin Images': 'Lägg till adminbilder',
  'Edit Admin Comment': 'Redigera adminkommentar',
  'Original User Comment': 'Ursprunglig användarkommentar',
  'Original comment (read-only)': 'Ursprunglig kommentar (skrivskyddad)',
  'Enter admin comment...': 'Ange adminkommentar...',
  'This comment will be added by admin and preserved alongside the original user comment.': 'Denna kommentar kommer att läggas till av admin och bevaras tillsammans med den ursprungliga användarkommentaren.',
  'Edit General Comments': 'Redigera allmänna kommentarer',
  'Enter general comments...': 'Ange allmänna kommentarer...',
  'Failed to update comment': 'Misslyckades med att uppdatera kommentar',
  'Failed to update general comments': 'Misslyckades med att uppdatera allmänna kommentarer',
  'Image': 'Bild',
  'Risk Report': 'Riskrapport',
  'General Comments': 'Allmänna kommentarer',
  'Additional Risk Assessment': 'Ytterligare riskbedömning',
  'Additional Observations': 'Ytterligare observationer',
  'Use this section to document any additional risks not covered by the standard questions above': 'Använd detta avsnitt för att dokumentera eventuella ytterligare risker som inte täcks av standardfrågorna ovan',
  'Is there anything else you would like to report? If so, please describe it and assess the risk level.': 'Finns det något annat du vill rapportera? I så fall, beskriv det och bedöm risknivån.',
  'Description / Comments': 'Beskrivning / Kommentarer',
  'Describe any additional observations, risks, or concerns...': 'Beskriv eventuella ytterligare observationer, risker eller farhågor...',
  'You can select multiple images to document your observations': 'Du kan välja flera bilder för att dokumentera dina observationer',
  'Risk Level Assessment': 'Risknivåbedömning',
  'If you have identified a risk above, please assess its level': 'Om du har identifierat en risk ovan, vänligen bedöm dess nivå',
  'No Additional Risk': 'Ingen ytterligare risk',
  'Risk Description': 'Riskbeskrivning',
  'Describe the identified risk...': 'Beskriv den identifierade risken...',
  'Edit Additional Risk': 'Redigera ytterligare risk',
  'Edit Additional Observations': 'Redigera ytterligare observationer',
  'Add Additional Observations': 'Lägg till ytterligare observationer',
  'Failed to update additional risk': 'Misslyckades med att uppdatera ytterligare risk',
  'Failed to upload images for additional risk. The report will be saved without these images.': 'Misslyckades med att ladda upp bilder för ytterligare risk. Rapporten sparas utan dessa bilder.',
  'Failed to upload images for additional observations. The report will be saved without these images.': 'Misslyckades med att ladda upp bilder för ytterligare observationer. Rapporten sparas utan dessa bilder.',
  'Enter any additional general comments...': 'Ange eventuella allmänna kommentarer...',
  'Create Work Order': 'Skapa arbetsorder',
  'Mark all as OK': 'Markera alla som OK',
  'Work Order Title': 'Arbetsordertitel',
  'RED': 'RÖD',
  'ORANGE': 'ORANGE',
  'YELLOW': 'GUL',
  'GREEN': 'GRÖN',
  'Low': 'Låg',
  'Medium': 'Medel',
  'High': 'Hög',
  'Enter work order title/name': 'Ange arbetsordertitel/namn',
  'Safety requirements to be checked:': 'Säkerhetskrav som ska kontrolleras:',
  'All above safety requirements are OK': 'Alla ovanstående säkerhetskrav är OK',
  'Enter any additional safety comments...': 'Ange eventuella ytterligare säkerhetskommentarer...',
  'Add details about this risk...': 'Lägg till detaljer om denna risk...',
  'Upload Images': 'Ladda upp bilder',
  'Choose images...': 'Välj bilder...',
  'You can select multiple images': 'Du kan välja flera bilder',
  'No Risks Identified / All OK': 'Inga risker identifierade / Allt OK',
  'Add general comments': 'Lägg till allmänna kommentarer',
  'High Risk Identified': 'Hög risk identifierad',
  'Understood': 'Förstått',
  'Images': 'Bilder',
  'Select customer': 'Välj kund',
  'Current Status': 'Status',
  'Overall Risk Assessment': 'Nuvarande riskbedömning',
  'You have marked a high risk - Please call': 'Du har markerat en hög risk - Vänligen ring',
  'Loading risk questions...': 'Laddar riskfrågor...',
  'Please fill in the work order title': 'Vänligen fyll i arbetsordertiteln',
  'Please complete the risk assessment': 'Vänligen slutför riskbedömningen',
  'All questions marked as No Risk': 'Alla frågor markerade som Ingen Risk',
  'Failed to create work order': 'Misslyckades med att skapa arbetsorder',
  'You can select multiple images (max 1MB each)': 'Du kan välja flera bilder (max 1MB var)',
  'Images uploaded successfully': 'Bilder uppladdade framgångsrikt',
  'Failed to upload images': 'Misslyckades med att ladda upp bilder',
  'Loading...': 'Laddar...',
  'Browse': 'Bläddra',
  'User Images': 'Användarbilder',
  'Admin Images': 'Adminbilder',
  'Add Images': 'Lägg till bilder',
  'Edit Comment': 'Redigera kommentar',
  'User Comment': 'Användarkommentar',
  'Admin Comment': 'Adminkommentar',
  'Admin Actions': 'Adminåtgärder',
  'Failed to add images': 'Misslyckades med att lägga till bilder',
  'Failed to add risk row': 'Misslyckades med att lägga till riskriad',
  'Print functionality will be implemented in Task 13': 'Utskriftsfunktionalitet kommer att implementeras i Uppgift 13',
  'Enter risk question...': 'Ange riskfråga...',
  'Risk levels determine the severity of identified hazards': 'Risknivåer bestämmer allvarlighetsgraden av identifierade faror',
  'Low risk situations': 'Låg risksituationer',
  'Medium risk requiring attention': 'Medelhög risk som kräver uppmärksamhet',
  'High risk requiring immediate action': 'Hög risk som kräver omedelbar åtgärd',
  'Confirm Archive': 'Bekräfta arkivering',
  'Are you sure you want to archive this risk question?': 'Är du säker på att du vill arkivera denna riskfråga?',
  'Archived questions will no longer appear in new risk assessments but will remain visible in historical reports.': 'Arkiverade frågor kommer inte längre att visas i nya riskbedömningar men kommer fortfarande att synas i historiska rapporter.',
  'Error creating risk question': 'Fel vid skapande av riskfråga',
  'Error archiving risk question': 'Fel vid arkivering av riskfråga',
  'Work Details': 'Arbetsdetaljer',
  'Complete': 'Slutför',
  'Enter basic work order information': 'Ange grundläggande arbetsordreinformation',
  'Complete safety risk evaluation': 'Slutför säkerhetsriskbedömning',
  'Complete work order details first': 'Slutför arbetsordedetaljer först',
  'Ready to Create Work Order': 'Redo att skapa arbetsorder',
  'All required information has been completed': 'All nödvändig information har fyllts i',
  'Failed to upload image': 'Misslyckades med att ladda upp bild',
  'Failed to process image': 'Misslyckades med att bearbeta bild',
  'Failed to upload images for question': 'Misslyckades att ladda upp bilder för fråga',
  'The report will be saved without these images.': 'Rapporten kommer att sparas utan dessa bilder.',
  'Uploading...': 'Laddar upp...',
  'Min Stock': 'Minsta lager',
  'Not set': 'Ej satt',
  'Min stock must be a positive number or empty': 'Minsta lager måste vara ett positivt tal eller tomt',
  'Min stock level updated': 'Minsta lagernivå uppdaterad',
  'Failed to update min stock level': 'Kunde inte uppdatera minsta lagernivå',
  'Stock enabled for article': 'Lagerhållning aktiverad för artikel',
  'Article not found': 'Artikel hittades inte',
  'Steel Pipes': 'Mediarör (stål)',
  'Plastic Jackets': 'Mantelrör (plast)',
  'Pipe-Jacket Mappings': 'Rör-Mantel Kopplingar',
  'Nominal diameter (DN)': 'Nominell diameter (DN)',
  'Outside diameter (Dy)': 'Ytterdiameter (Dy)',
  'Wall thickness (s)': 'Väggtjocklek (s)',
  'Outside diameter casing (Dym)': 'Ytterdiameter mantel (Dym)',
  'Outside diameter bend sleeve (Dybm)': 'Ytterdiameter bojmuff (Dybm)',
  'Wall thickness casing (tm)': 'Väggtjocklek mantel (tm)',
  'Wall thickness bend sleeve (tbm)': 'Väggtjocklek bojmuff (tbm)',
  'Shrink sleeve (shrink)': 'Krympmuff (shrink)',
  'Add Steel Pipe': 'Lägg till stålrör',
  'Add Plastic Jacket': 'Lägg till mantelrör',
  'Add Mapping': 'Lägg till koppling',
  'Show deleted': 'Visa borttagna',
  'Restore': 'Återställ',
  'Serie': 'Serie',
  'Pipes': 'Rör',
  'Single': 'Enkel',
  'Steel Pipe': 'Stålrör',
  'Plastic Jacket': 'Mantelrör',
  'A deleted entry with this dimension exists': 'En borttagen post med denna dimension finns redan',
  'This dimension already exists': 'Denna dimension finns redan',
  'This mapping already exists': 'Denna koppling finns redan',
  'A user with this email already exists': 'En användare med denna e-postadress finns redan',
  'Something went wrong': 'Något gick fel',
  'A deleted mapping with these values exists': 'En borttagen koppling med dessa värden finns redan',
  'Failed to create entry': 'Kunde inte skapa post',
  'Failed to delete entry': 'Kunde inte ta bort post',
  'Failed to restore entry': 'Kunde inte återställa post',
  'Deleted': 'Borttagen',
  'Restored': 'Återställd',
  'Bend Types': 'Böjtyper',
  'Bend Type': 'Böjtyp',
  'Radius (R)': 'Radie (R)',
  'Add Bend Type': 'Lägg till böjtyp',
  'Welding': 'Svetsning',
  'Insulation': 'Isolering',
  'Inspections': 'Inspektioner',
  'Alarm Connected': 'Alarm anslutet',
  'Alarm Tested': 'Alarm testat',
  'Pressure Tested': 'Trycktestat',
  'Visual Inspection': 'Visuell inspektion',
  'Toggle all': 'Ändra alla',
  'Approved': 'Godkänd',
  'Rejected': 'Underkänd',
  'Selected joints': 'Valda skarvar',
  'Clear all': 'Rensa alla',
  'No joints selected': 'Inga skarvar valda',
  'Are you sure you want to clear all selected joints?': 'Är du säker på att du vill rensa alla valda skarvar?',
  'My Reports': 'Mina rapporter',
  'My joint reports': 'Mina svetsrapporter',
  'Joint Count': 'Antal skarvar',
  'No reports found': 'Inga rapporter hittades',
  'Report Summary': 'Rapportsammanfattning',
  'Total Joints': 'Totalt antal skarvar',
  'Dimensions': 'Dimensioner',
  'Address': 'Adress',
  'Orderer': 'Beställare',
  'Client': 'Beställare',
  'Stage': 'Etapp',
  'Customer Project/Ref': 'Kundprojekt/Ref',
  'Drawing No.': 'Ritningsnr',
  'Resistance': 'Resistans',
  'Installer': 'Montör',
  'Address/City': 'Adress/Ort',
  'Alarm Supply': 'Larm tillopp',
  'Alarm Return': 'Larm retur',
  'Alarm Twin': 'Larm twin',
  'Isolation Supply': 'Isolation tillopp',
  'Isolation Return': 'Isolation retur',
  'Alarm tested': 'Larm testat',
  'Pressure tested': 'Trycktestning',
  'Visual inspection': 'Visuell inspektion',
  'Editable dimension': 'Redigerbar dimension',
  'DEV: Fields': 'DEV: Fält',
  'Header fields': 'Huvudfält',
  'Row fields': 'Radfält',
  'Report field configuration': 'Rapportfält-konfiguration',
  'Report Information': 'Rapportinformation',
  'Enter report name': 'Ange rapportnamn',
  'Report Name': 'Rapportnamn',
  'Joint Details': 'Skarvdetaljer',
  'Review & Print': 'Granska & Skriv ut',
  'No joints selected. Go back to select joints.': 'Inga skarvar valda. Gå tillbaka för att välja skarvar.',
  'Add note...': 'Lägg till anteckning...',
  'No temperature data': 'Ingen temperaturdata',
  'Voltage': 'Spänning',
  'Channel': 'Kanal',
  'Weld Time': 'Svetstid',
  'Coil': 'Slinga',
  'Isolation': 'Isolation',
  'To (tillopp)': 'Tillopp',
  'From (retur)': 'Retur',
  'Field Mode': 'Fältläge',
  'Select or create report': 'Välj eller skapa rapport',
  'Create new report': 'Skapa ny rapport',
  'New report name': 'Nytt rapportnamn',
  'Weld ID': 'Skarv-ID',
  'Save weld': 'Spara skarv',
  'Update weld': 'Uppdatera skarv',
  'Cancel edit': 'Avbryt redigering',
  'Report welds': 'Rapportskarvar',
  'Start over': 'Börja om',
  'Take photo': 'Ta foto',
  'Photo attached': 'Foto bifogat',
  'Alarm resistance': 'Slingresistans Ω',
  'Insulation resistance': 'Isolationsresistans Ω',
  'Notes': 'Anteckningar',
  'Generating PDF...': 'Genererar PDF...',
  'Remove logo': 'Ta bort logotyp',
  'Customer logo': 'Kundlogotyp',
  'Are you sure you want to delete this report?': 'Är du säker på att du vill ta bort denna rapport?',
  'Are you sure you want to remove this joint?': 'Är du säker på att du vill ta bort denna skarv?',
  'Are you sure you want to remove this joint from the report?': 'Är du säker på att du vill ta bort denna skarv från rapporten?',
  'Weld saved': 'Svets sparad',
  'Weld saved locally': 'Svets sparad lokalt',
  'Weld saved but ID not found in database': 'Svets sparad men ID hittades inte i databasen',
  'Failed to sync weld to server': 'Misslyckades att synka svets till servern',
  'Photo uploaded': 'Foto uppladdat',
  'Photos': 'Foton',
  'Retry': 'Försök igen',
  'Saving...': 'Sparar...',
  'Edit Report': 'Redigera rapport',
  'Completed': 'Slutförd',
  'Failed to save report': 'Kunde inte spara rapport',
  'Supply': 'Tillopp',
  'Return': 'Retur',
  'New Report': 'Ny rapport',
  'All Reports': 'Alla rapporter',
  'Mark as Printed': 'Markera som utskriven',
  'Report marked as printed': 'Rapport markerad som utskriven',
  'All joint reports': 'Alla svetsrapporter',
  'Reports': 'Rapporter',
  'Create PDF': 'Skapa PDF',
  'Not yet matched to machine data': 'Denna skarv lades till via fältläge. Det finns ingen matchande data i databasen ännu. Antingen har svetsmaskinen inte synkat sin data ännu, eller så angavs fel skarv-ID.',
  'Match': 'Koppla',
  'No matching joint found': 'Ingen matchande skarv hittades',
  'Multiple matches found': 'Flera matchningar hittades',
  'Select matching joint': 'Välj matchande skarv',
  'Matched successfully': 'Kopplad',
  'Source': 'Källa',
  'INVALID WELD NO': 'OGILTIGT SKARV-NR'
}



// WEBPACK FOOTER //
// ./src/translations/sv.js